import { memo, useEffect, useRef, useState } from "react";
import { useTheme } from "../context/ThemeContext";

const TradingViewWidget = ({ symbol = "NASDAQ:AAPL", interval = "60" }) => {
  const container = useRef(null);
  const { theme } = useTheme() || { theme: "dark" };
  const isLight = theme === "light";
  const [size, setSize] = useState({ w: 0, h: 0, mobile: false });

  useEffect(() => {
    const measure = () => {
      const node = container.current;
      if (!node) return;
      setSize({
        w: Math.round(node.clientWidth),
        h: Math.round(node.clientHeight),
        mobile: window.innerWidth < 768,
      });
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  useEffect(() => {
    const node = container.current;
    if (!node || !size.w) return;
    node.replaceChildren();
    const holder = document.createElement("div");
    holder.className = "tradingview-widget-container__widget";
    holder.style.height = "100%";
    holder.style.width = "100%";
    node.appendChild(holder);
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    script.text = JSON.stringify({
      allow_symbol_change: true,
      calendar: false,
      details: false,
      hide_side_toolbar: size.mobile,
      hide_top_toolbar: false,
      hide_legend: size.mobile,
      hide_volume: size.mobile,
      hotlist: false,
      interval,
      locale: "br",
      save_image: true,
      style: "1",
      symbol,
      theme: isLight ? "light" : "dark",
      timezone: "Etc/UTC",
      backgroundColor: isLight ? "#ffffff" : "#05070C",
      gridColor: isLight ? "rgba(46, 46, 46, 0.2)" : "rgba(242, 242, 242, 0.08)",
      watchlist: [],
      withdateranges: false,
      compareSymbols: [],
      support_host: "https://www.tradingview.com",
      studies: [],
      // Tamanho customizado no mobile (375x667), autosize no desktop
      ...(size.mobile
        ? { autosize: false, width: size.w || 375, height: 667 }
        : { autosize: true }),
    });
    node.appendChild(script);
  }, [symbol, interval, isLight, size]);

  return (
    <div
      data-testid="tradingview-chart"
      className="tradingview-widget-container h-full w-full overflow-hidden"
      ref={container}
      style={{ height: "100%", width: "100%" }}
    />
  );
};

export default memo(TradingViewWidget);
